import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';
import NewsCard from '../components/NewsCard';
import SEO from '../components/SEO';
import './SearchPage.css';

function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const category = searchParams.get('category');
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!query) return;

      try {
        setLoading(true);
        let url = `/api/news?search=${encodeURIComponent(query)}`;
        if (category) url += `&category=${encodeURIComponent(category)}`;
        const response = await api.get(url);

        if (response.data.success) {
          setNews(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching search results:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [query]);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="search-page">
      {/* SEO Meta Tags */}
      <SEO
        title={`"${query}" की खोज - RR NEWS TV FASTEST UPDATE`}
        description={`RR NEWS TV FASTEST UPDATE पर "${query}" से संबंधित खबरें और समाचार खोजें`}
        keywords={`${query}, खोज, RR NEWS TV FASTEST UPDATE, समाचार`}
        url={`/search?q=${query}`}
        noIndex={true}
      />
      
      <div className="container">
        <h1 className="page-title">
          🔍 "{query}" के लिए खोज परिणाम
        </h1>

        {news.length === 0 ? (
          <div className="no-results">
            <p>कोई परिणाम नहीं मिला।</p>
            <p className="suggestion">कृपया अन्य keywords के साथ खोजें।</p>
          </div>
        ) : (
          <>
            <p className="results-count">
              {news.length} परिणाम मिले
            </p>
            <div className="news-grid">
              {news.map((item) => (
                <NewsCard key={item._id} news={item} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SearchPage;


